import MaskedValue from "common/MaskedValue";
import styled from "styled-components";
import { MASK_TYPE, SellDraft } from "types";
import * as fields from "pages/transactions/sellDraftFieldDefinitions";

export default function SellDraftFeeSection(props: { transaction: SellDraft }) {
  const cadValue = fields.draftAmountCADValue.getValue(props.transaction) ?? 0;
  const draftFee = props.transaction.waiveFee === true ? 0 : 10;

  return (
    <TotalSection>
      <LeftSection>
        <LightBold>Fee</LightBold>
        {MaskedValue(MASK_TYPE.MONEY, draftFee.toString())}
        <Spacer />
        CAD
        {/* {props.transaction.cash?.cashCurrencyType?.toUpperCase()} */}
      </LeftSection>
      {props.transaction.currencyType === "usd" && (
        <RightSection>
          ( <LightBold>Draft CAD Value </LightBold>{" "}
          {MaskedValue(MASK_TYPE.MONEY, cadValue.toString())}
          <Spacer />
          CAD)
        </RightSection>
      )}
    </TotalSection>
  );
}

const LightBold = styled.div`
  font-weight: 500;
  margin-right: 10px;
`;
const LeftSection = styled.div`
  flex: 1;
  display: flex;
`;
const RightSection = styled.div`
  text-align: right;
  display: flex;
`;
const Spacer = styled.div`
  margin-right: 5px;
`;
const TotalSection = styled.div`
  margin: 1em;
  display: flex;
  align-items: center;
`;
